import loadable from '@loadable/component';

const RecommendationsLoader = loadable(() =>
  import(/* webpackChunkName: "secondary-content" */ './recommendation-model')
);

export default RecommendationsLoader;
